module.exports = __webpack_public_path__ + "img/Warranty.7d4e0b97.svg";